// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__9AX-S","col":"styles_col__Zzw1A"};